import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d5353dc8")

_pushScopeId("data-v-d5353dc8")
const _hoisted_1 = {
  key: 0,
  class: "pt6"
}
const _hoisted_2 = { class: "d-flex justify-content-between py-2" }
const _hoisted_3 = { class: "requiredItemsTitle pt6" }
const _hoisted_4 = { class: "text-r" }
const _hoisted_5 = { class: "text-length-title" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" /150 ")
const _hoisted_7 = {
  key: 1,
  class: "d-flex justify-content-between"
}
const _hoisted_8 = {
  key: 0,
  class: "requiredItemsTitle"
}
const _hoisted_9 = {
  key: 1,
  class: "requiredItemsTitle"
}
const _hoisted_10 = {
  key: 2,
  class: "requiredItemsTitle"
}
const _hoisted_11 = {
  key: 0,
  class: "d-flex py-2"
}
const _hoisted_12 = { class: "requiredItemsTitle" }
const _hoisted_13 = { class: "text-r" }
const _hoisted_14 = { class: "text-length-title" }
const _hoisted_15 = { class: "text-length-title" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" /300 ")
const _hoisted_17 = {
  key: 3,
  class: "moreInfoDescription"
}
const _hoisted_18 = {
  key: 0,
  style: {"padding":"0 10px","margin-left":"auto"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: [_ctx.editMode ? 'editMode' : 'viewMode', "w-100 ProductMoreInfo"],
      style: {"padding":"0 10px"}
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.infos, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ["moreInfo-main-block", { 'custom-block': item.type == _ctx.productInfoType.Custom }],
          key: index
        }, [
          (_ctx.editMode && item.type == _ctx.productInfoType.Custom)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('product.moreAboutProduct.title')), 1),
                    (_ctx.editMode && item.id)
                      ? (_openBlock(), _createBlock("i", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.addTranslations(item.id, item.type)),
                          class: "icon-f icon-earth-shape fs-20 pl10"
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("span", {
                    class: "icon-f icon-delete-cross fs-16",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeCustomInfoType && _ctx.removeCustomInfoType(...args)))
                  })
                ]),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  required: "",
                  maxlength: "150",
                  "onUpdate:modelValue": ($event: any) => (item.title = $event),
                  class: "bookit-input product-input form-control h48"
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, item.title]
                ]),
                _createVNode("div", _hoisted_4, [
                  _createVNode("span", _hoisted_5, [
                    _createVNode("span", {
                      class: { 'length-limit': item.title.length > 149 }
                    }, _toDisplayString(item.title.length), 3),
                    _hoisted_6
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_7, [
                (item.type == _ctx.productInfoType.General)
                  ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('product-info.title.important')), 1))
                  : (item.type == _ctx.productInfoType.Covid19)
                    ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('product-info.title.covid19')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(item.title), 1)),
                (_ctx.editMode && item.id)
                  ? (_openBlock(), _createBlock("i", {
                      key: 3,
                      onClick: ($event: any) => (_ctx.addTranslations(item.id, item.type)),
                      class: "icon-f icon-earth-shape fs-20 pl10"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])),
          (_ctx.editMode)
            ? (_openBlock(), _createBlock("div", {
                key: 2,
                class: item.type == _ctx.productInfoType.Custom ? 'pt2' : 'pt6'
              }, [
                (item.type == _ctx.productInfoType.Custom)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('product.moreAboutProduct.description')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("textarea", {
                  required: item.type == _ctx.productInfoType.Custom,
                  name: "textArea",
                  id: "arrivalInstructions",
                  class: "bookit-textarea product-textarea resize-off long-description form-control",
                  maxlength: "300",
                  "onUpdate:modelValue": ($event: any) => (item.description = $event)
                }, "\n        ", 8, ["required", "onUpdate:modelValue"]), [
                  [_vModelText, item.description]
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("span", _hoisted_14, [
                    _createVNode("span", _hoisted_15, [
                      _createVNode("span", {
                        class: { 'length-limit': item.description.length > 299 }
                      }, _toDisplayString(item.description.length), 3),
                      _hoisted_16
                    ])
                  ])
                ])
              ], 2))
            : (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(item.description), 1))
        ], 2))
      }), 128))
    ], 2),
    (_ctx.editMode && !_ctx.existCustomInfoType)
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          _createVNode("span", {
            class: "icon dark-squared-plus",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addCustomInfoType && _ctx.addCustomInfoType(...args)))
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
})